import { FormControl, FormControlLabel, FormLabel, Radio } from '@mui/material';
import { Box } from '@mui/system';
import { ReactElement, JSXElementConstructor, ReactNode, ReactPortal } from 'react';

type OptionType = {
  value: unknown;
  label:
    | string
    | number
    | boolean
    | ReactElement<any, string | JSXElementConstructor<any>>
    | Iterable<ReactNode>
    | ReactPortal
    | null
    | undefined;
};

interface InputRadioProps {
  options: OptionType[];
  value: unknown;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  name: string;
  label: ReactNode;
  direction?: 'row' | 'column';
}

const InputRadio: React.FC<InputRadioProps> = ({
  options,
  value,
  onChange,
  name,
  label,
  direction = 'row'
}) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="label" className={'regular'}>
        {label}
      </FormLabel>
      <Box sx={{ display: 'flex', flexDirection: direction, gap: direction === 'row' ? 2 : 0 }}>
        {options.map(
          (option: {
            value: unknown;
            label:
              | string
              | number
              | boolean
              | ReactElement<any, string | JSXElementConstructor<any>>
              | Iterable<ReactNode>
              | ReactPortal
              | null
              | undefined;
          }) => (
            <FormControlLabel
              key={String(option.value)}
              control={
                <Radio
                  checked={value === option.value}
                  onChange={onChange}
                  value={option.value}
                  name={name}
                />
              }
              label={option.label}
            />
          )
        )}
      </Box>
    </FormControl>
  );
};

export default InputRadio;
